import CampaignTable from './campaign-table';

export default CampaignTable;
